/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnly from '@ember/component/template-only';
import type { BookingLogsSignature } from 'uplisting-frontend/components/ui/booking/logs';

const UiBookingV2LogsComponent = templateOnly<BookingLogsSignature>();

export default UiBookingV2LogsComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::BookingV2::Logs': typeof UiBookingV2LogsComponent;
  }
}
